module.exports = __webpack_public_path__ + "img/chain17.73a3ee11.png";